<template>
  <q-slide-item
    data-test-id="kitchen-order-item-expansion-slide-item"
    class="no-wrap"
    :style="{
      'border-left': `8px solid ${orderCardStyles.background}`,
      'color': textColor,
      'background-color': backgroundColor
    }"
    left-color="negative"
    right-color="positive"
    @left="({ reset }) => handleSwipeLeft(reset)"
    @right="({ reset }) => handleSwipeRight(reset)"
    @click="promptOrderActions()"
  >
    <template
      v-if="canSwipeLeft"
      #left
    >
      <q-icon
        name="backspace"
        left
      />
    </template>
    <template
      v-if="canSwipeRight"
      #right
    >
      <q-icon
        name="checkmark"
        right
      />
    </template>
    <q-expansion-item
      :model-value="modelValue"
      data-test-id="kitchen-order-item-expansion-item"
      header-style="padding: 0;"
      expand-icon-class="kitchen-order-item-expansion-item-icon"
      expand-icon-toggle
    >
      <template #header>
        <div class="full-width row justify-between items-center">
          <kitchen-order-item-item
            style="padding: 2px 0px 2px 8px;"
            :index="index"
            :kitchen-display="kitchenDisplay"
            :order="order"
            :order-items="orderItems"
            :tab="tab"
            :show-preparation-counter="showPreparationCounter"
            :show-prep-icon="readyToPrep"
            :relative-prep-time-label="relativePrepTime"
          />
          <q-btn
            :icon="!!modelValue ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            size="md"
            square
            outline
            flat
            stretch
            @click.stop="expand"
          />
        </div>
      </template>
    </q-expansion-item>
  </q-slide-item>
</template>

<script>
import KitchenOrderItemItem from 'src/modules/kds/components/kitchen-card/KitchenOrderItemItem'
import KitchenCardMixin from 'src/modules/kds/components/kitchen-card/mixins/KitchenCardMixin'

export default {
  name: 'KitchenOrderItemExpansionItem',
  components: {
    KitchenOrderItemItem
  },
  configuration: ['currentSite'],
  mixins: [KitchenCardMixin],
  props: {
    modelValue: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value'],
  computed: {
    // All orderItems are the same when grouped in an expansion / slide item, so we can just use the first one for all operations
    orderItem () {
      return _.first(this.orderItems)
    },
    backgroundColor () {
      if (this.selected) {
        return this.$lightenColor(this.currentSite.accentColor, this.$isColorDark(this.currentSite.accentColor) ? 15 : -15)
      }

      return '#FFFFFF'
    },
    textColor () {
      return this.$isColorDark(this.backgroundColor) ? 'white' : 'black'
    }
  },
  methods: {
    expand () {
      this.$emit('update:model-value', !this.modelValue)
    }
  }
}
</script>

<style>
.kitchen-order-item-expansion-item-icon {
  display: none;
}
</style>
